<template>
	<div>
    <router-link to="/login">
      <button class="login-button">ログイン</button>
    </router-link>
	</div>
</template>

<script>
export default {
  name: 'LoginButton',
}
</script>

<style lang="scss" scoped>
.login-button {
  background-color: #DFDFDF;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  width: 200px;
  height: 40px;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/LoginButton.vue